<dx-popup
  [(visible)]="this.visible"
  [width]="360"
  height="auto"
  [showTitle]="true"
  title="New Independent Portfolio"
  [dragEnabled]="false"
  [position]="{ my: 'center', at: 'center', of: window }"
  (onHidden)="this.onHidden()"
  [wrapperAttr]="{ class: 'hg-create-portfolio-popup' }"
>
  <div *dxTemplate="let data of 'content'">
    <div class="form">

      <div class="field">
        <div class="label">Name</div>
        <dx-text-box [(value)]="this.name"
                     placeholder="Portfolio name"
                     [showClearButton]="true">
        </dx-text-box>
      </div>

      <div class="field">
        <div class="label">Underlying <span class="hint">(set once — cannot be changed later)</span></div>
        <ets-symbol-picker (instrumentSelected)="this.onInstrumentSelected($event)"
                           [selectedInstrument]="this.tradingInstrument"
                           [showLastPrice]="false">
        </ets-symbol-picker>
      </div>

      <div class="field">
        <div class="label">Default Qty</div>
        <dx-number-box [(value)]="this.defaultQty"
                       [min]="1"
                       [showSpinButtons]="true">
        </dx-number-box>
      </div>

      <div class="actions">
        <dx-button text="Cancel" (onClick)="this.onCancel()"></dx-button>
        <dx-button text="Create" type="default" (onClick)="this.onCreate()"></dx-button>
      </div>

    </div>
  </div>
</dx-popup>
